export default "__VITE_ASSET__CzAB9jh4__"